"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const TabsSet_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/TabsSet.vue"));
const Tab_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/Tab.vue"));
const Loader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Loader.vue"));
const MapAttributions_vue_1 = __importDefault(require("@becrop/components/Rate/vue/components/MapAttributions.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
const BaseMapConnector_1 = require("@becrop/components/Toolkit/Common/models/BaseMapConnector");
const BaseMap_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/BaseMap.vue"));
const sleep_1 = __importDefault(require("@common/tsutils/sleep"));
const lodash_1 = __importDefault(require("lodash"));
const CLUSTER_COLOR_1 = '#3FB8B2';
const CLUSTER_COLOR_2 = '#6C3FB8';
const STANDARD_COLORS = [
    '#CECDCC',
    '#fac940',
    '#f4d58a',
    '#c3dcf0',
    '#85c5fa',
    '#1787e5',
];
let Map = class Map extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.fsactivemap = false;
        this.loading = true;
        this.connector = new BaseMapConnector_1.BaseMapConnector(this.map_config);
    }
    mounted() {
        this.connector.randomizeMarkerPosition(false);
        if (this.active) {
            this.startActive();
        }
    }
    async startActive() {
        await (0, sleep_1.default)(100);
        await this.onChangeActive();
    }
    async onChangeActive() {
        if (!this.active) {
            return;
        }
        this.loading = true;
        await this.connector.draw();
        await this.drawParcelsAndSamples();
        await (0, sleep_1.default)(300);
        this.loading = false;
    }
    async drawParcelsAndSamples() {
        this.connector.reset();
        this.drawCuster(this.samplesA, this.samplesB, CLUSTER_COLOR_1);
        this.drawCuster(this.samplesB, this.samplesA, CLUSTER_COLOR_2);
        // TODO: colors
        this.drawMixedParcels(this.samplesA, this.samplesB, CLUSTER_COLOR_1, CLUSTER_COLOR_2);
        this.connector.center();
    }
    getUniqueParcels(samples) {
        const parcels = [];
        samples.forEach((sample) => {
            var _a;
            if ((_a = sample.sample.parcel) === null || _a === void 0 ? void 0 : _a.parcel_str) {
                parcels.push(sample.sample.parcel);
            }
        });
        return lodash_1.default.uniqBy(parcels, 'id');
    }
    drawCuster(samples, others, color) {
        let parcels = this.getUniqueParcels(samples);
        const otherParcels = this.getUniqueParcels(others);
        parcels = lodash_1.default.differenceBy(parcels, otherParcels, 'id');
        parcels.forEach((parcel) => {
            this.connector.drawPolygon({
                color: color,
                shape: parcel.parcel_str,
            });
        });
        samples.forEach((sample) => {
            var _a;
            this.connector.drawMarker({
                color: STANDARD_COLORS[(_a = sample.rank) !== null && _a !== void 0 ? _a : 0],
                text: sample.sample.code,
                lat: sample.sample.location.lat,
                lon: sample.sample.location.lon,
            });
        });
    }
    drawMixedParcels(samplesA, samplesB, color, colorB) {
        const parcelsA = this.getUniqueParcels(samplesA);
        const parcelsB = this.getUniqueParcels(samplesB);
        const parcels = lodash_1.default.intersectionBy(parcelsA, parcelsB, 'id');
        parcels.forEach((parcel) => {
            const options = {
                color: colorB ? undefined : color,
                dash: colorB ? [color, colorB] : undefined,
                shape: parcel.parcel_str,
            };
            this.connector.drawPolygon(options);
        });
    }
    closeMap() {
        this.$emit('onclosemap');
    }
    downloadMap() {
        this.connector.download();
    }
    onFullscreenChange(fullscreen) {
        this.fsactivemap = fullscreen;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Map.prototype, "active", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Map.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Map.prototype, "samplesA", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Map.prototype, "samplesB", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('active')
], Map.prototype, "onChangeActive", null);
Map = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TabsSet: TabsSet_vue_1.default,
            Tab: Tab_vue_1.default,
            Download: lucide_vue_next_1.Download,
            Maximize2: lucide_vue_next_1.Maximize2,
            X: lucide_vue_next_1.X,
            Info: lucide_vue_next_1.Info,
            HelpCircle: lucide_vue_next_1.HelpCircle,
            Loader: Loader_vue_1.default,
            BaseMap: BaseMap_vue_1.default,
            MapAttributions: MapAttributions_vue_1.default,
        },
    })
], Map);
exports.default = Map;
